import type { Extractor } from "../types.js";

export const extractSymbol: Extractor = () => ({ type: "symbol" });
